// extracted by mini-css-extract-plugin
module.exports = {"Wideboard":"ads_Wideboard__3FPab"};